// @flow
import type { ActionsState } from '~/core/state/actions/types';
import type { RouteProps } from '~/core/types/route-props';

import { connect } from 'react-redux';
import { noop } from 'lodash/fp';
import { getActions, getTemplates, loadForm } from '~/core/state/actions/actions';
import { currentSavingState, getAction, initialiseFormFromAction } from '~/core/state/actions/selectors';
import Component from './component';
import { withRouter } from 'react-router';
import { TAB_KEY } from './constants';

type OwnProps = {
    tagDeviceType?: string
} & RouteProps;

const FILTER = 'filter';
const ACTION_ID = 'actionId';

function getQueryStringValue(props: RouteProps, key: string) {
    const { location: { search } } = props;
    const queryString = new URLSearchParams(search);
    const filterValue = queryString.get(key);

    return filterValue;
}

const mapStateToProps = (state: { actions: ActionsState }, ownProps: OwnProps) => {
    const { tagDeviceType } = ownProps;
    const queryStringFilter = getQueryStringValue(ownProps, FILTER);
    const currentQueryStringTab = getQueryStringValue(ownProps, TAB_KEY);

    const actionId = getQueryStringValue(ownProps, ACTION_ID);
    const actionIdExists = !!getAction(state, { actionId });

    const savingState = currentSavingState(state);

    return {
        currentQueryStringTab,
        formAction: actionIdExists && initialiseFormFromAction(state, { actionId }),
        savingState,
        tagDeviceType: tagDeviceType || queryStringFilter
    };
};

const mapDispatchToProps = {
    getActions,
    getTemplates,
    loadForm
};

const mergeProps = ({ schedule, ...restStateProps }, dispatchProps, ownProps) => {
    const { formAction } = restStateProps;
    const { loadForm, ...restDispatchProps } = dispatchProps;

    return {
        ...restStateProps,
        ...restDispatchProps,
        ...ownProps,
        loadActionIdForm: formAction ? () => loadForm(formAction) : noop
    };
};
// $FlowFixMe
export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(Component));



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/index.js